import axios from "axios";
import {
  ContractEditRequest,
  // ContractImportRequest,
  ContractSearchRequest,
} from "./ContractForm";
import { AxiosResponse } from "axios";
import { ContractCreateRequest, ContractEditForm } from "./ContractForm";
import { ApplicationApi, ApplicationProtectedRouting } from "../../../Routing";
import { Utility } from "../../../utils/Utility";

/**
 * 契約情報管理 API
 */
export class ContractService {
  // 契約情報一覧取得API
  findByConditions = async (
    param: ContractSearchRequest
  ): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.post(
        ApplicationProtectedRouting.contract.apiUrl(),
        param
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // 契約情報詳細取得API
  findByContractId = async (id: string): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.get(
        ApplicationProtectedRouting.contractDetail.apiUrl(id)
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // 契約情報情報新規作成確認API
  createConfirm = async (param: ContractEditForm): Promise<AxiosResponse> => {
    try {
      const defaultCreateDate = new Date(0);
      let request = new ContractCreateRequest();
      if (param.startView !== null) {
        let contractStart = Utility.registDateFormat(
          param.startView.toLocaleString()
        );
        param.contractStart = contractStart || "";
      }
      if (param.endView !== null) {
        let contractEnd = Utility.registDateFormat(
          param.endView.toLocaleString()
        );
        param.contractEnd = contractEnd || "";
      }
      param.createUser = "PreUser";
      param.createDate = Utility.registDateFormat(
        defaultCreateDate.toLocaleString()!
      ) || "";
      param.updateUser = "PreUser";
      param.updateDate = Utility.registDateFormat(
        defaultCreateDate.toLocaleString()!
      ) || "";
      request.createdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.contractCreateConfirm.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // 契約情報情報新規作成API
  create = async (param: ContractEditForm): Promise<AxiosResponse> => {
    try {
      let request = new ContractCreateRequest();
      const defaultCreateDate = new Date(0);

      if (param.startView !== null) {
        let contractStart = Utility.registDateFormat(
          param.startView.toLocaleString()
        );
        param.contractStart = contractStart || "";
      }
      if (param.endView !== null) {
        let contractEnd = Utility.registDateFormat(
          param.endView.toLocaleString()
        );
        param.contractEnd = contractEnd || "";
      }
      param.createUser = "PreUser";
      param.createDate = Utility.registDateFormat(
        defaultCreateDate.toLocaleString()!
      );
      param.updateUser = "PreUser";
      param.updateDate = Utility.registDateFormat(
        defaultCreateDate.toLocaleString()!
      );
      request.createdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.contractCreateExecute.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // 契約情報情報編集取得API
  findByEditId = async (id: string): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.get(
        ApplicationProtectedRouting.contractEdit.apiUrl(id)
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // 契約情報情報編集確認API
  updateConfirm = async (param: ContractEditForm): Promise<AxiosResponse> => {
    try {
      let request = new ContractEditRequest();

      if (param.startView !== null) {
        let contractStart = Utility.registDateFormat(
          param.startView.toLocaleString()
        );
        param.contractStart = contractStart || "";
      }
      if (param.endView !== null) {
        let contractEnd = Utility.registDateFormat(
          param.endView.toLocaleString()
        );
        param.contractEnd = contractEnd || "";
      }
      request.editdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.contractEditConfirm.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // 契約情報情報編集API
  update = async (param: ContractEditForm): Promise<AxiosResponse> => {
    try {
      let request = new ContractEditRequest();

      if (param.startView !== null) {
        let contractStart = Utility.registDateFormat(
          param.startView.toLocaleString()
        );
        param.contractStart = contractStart || "";
      }
      if (param.endView !== null) {
        let contractEnd = Utility.registDateFormat(
          param.endView.toLocaleString()
        );
        param.contractEnd = contractEnd || "";
      }
      request.editdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.contractEditExecute.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // 契約情報情報削除API
  delete = async (contractId: string): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.post(ApplicationApi.contractDeleteExecute.apiUrl(), {
        contractId,
      });
      return res;
    } catch (err) {
      throw err;
    }
  };
  
}
